import CloseRounded from '@mui/icons-material/CloseRounded';
import React from 'react';
import SignInSignupComponent from '../../users/SigninSignupComponent';

const LoginSignUpModal = ({slModalopen, slModalClose, handleFormType, setLoggedIn}) => {
  return (
    <div className="fixed z-10 inset-0 bg-black bg-opacity-50 flex justify-center sm:items-center max-sm:items-end w-[100vw] backdrop-blur-sm">
      <div className="w-[850px] h-[600px] max-sm:w-[100dvw] max-sm:h-[90%] rounded-2xl bg-transparent relative flex items-end">
        <div className='w-full h-[95%] bg-white rounded-2xl'>
        <button onClick={slModalClose} className='absolute -top-0 left-1/2 -translate-x-1/2 bg-slate-300 rounded-full w-8 h-8 shadow-sm'>
          <CloseRounded />
        </button>
        <SignInSignupComponent slModalClose={slModalClose} setLoggedIn={setLoggedIn}/>
        </div>
      </div>
    </div>
  );
}

export default LoginSignUpModal